import GLightbox from 'glightbox'

export function initGLightbox() {
  const lightbox = GLightbox({
    selector: "[rel=glightbox]"
  });
}
